<template>
  <div>
    <div
      class="modal animated fadeIn"
      tabindex="-1"
      id="new-station"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >new station</small
                >
              </legend>
              <form @submit.prevent="newStation()">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>station name</label>
                      <input
                        type="text"
                        class="form-control station_name"
                        placeholder="station name"
                        required
                      />
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  class="btn btn-primary btn-flat creatingStation"
                >
                  <i class="fa fa-plus"></i> Add station
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-flat creatingStationLoader"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>
                  please wait...
                </button>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal animated fadeIn"
      tabindex="-1"
      id="new-consignee"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >new consignee</small
                >
              </legend>
              <form @submit.prevent="newConsignee()">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Consignee name</label>
                      <input
                        type="text"
                        class="form-control consignee_name"
                        placeholder="consignee name"
                        required
                      />
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  class="btn btn-primary btn-flat creatingConsignee"
                >
                  <i class="fa fa-plus"></i> Add consignee
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-flat creatingConsigneeLoader"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>
                  please wait...
                </button>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">New fuel allocation</div>
            <fieldset class="border p-3">
              <button
                type="button"
                class="btn btn-primary btn-roundec"
                data-toggle="modal"
                data-target="#new-station"
              >
                <i class="fa fa-plus"></i> new station
              </button>
              <p></p>
              <button
                type="button"
                class="btn btn-primary btn-roundec"
                data-toggle="modal"
                data-target="#new-consignee"
              >
                <i class="fa fa-plus"></i> new consignee
              </button>
              <p></p>
              <div>
                <form @submit.prevent="newFuel()">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Fuel Date</label>
                        <input
                          type="date"
                          class="form-control fuel_date input-rounded f-s-14"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="table-responsive">
                        <table class="table">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Fill date</th>
                              <th scope="col">Truck</th>
                              <th scope="col">Description</th>
                              <th scope="col">Litre</th>
                              <th scope="col">Rate/Litre</th>
                              <th scope="col">Total</th>
                              <th scope="col">Date of loading</th>
                              <th scope="col">Consignee</th>
                              <th scope="col">Petrol station</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(fuel_product, k) in fuelitemsRows"
                              :key="k"
                            >
                              <td scope="row">
                                <button
                                  type="button"
                                  class="btn btn-raised btn-raised-danger btn-sm m-1"
                                  @click="deleteRow(k, fuel_product)"
                                >
                                <i class="nav-icon i-Close-Window font-weight-bold"></i>
                                </button>
                              </td>
                              <td>
                                <input
                                  type="date"
                                  class="form-control fill_date"
                                  v-model="fuel_product.fill_date"
                                />
                              </td>
                              <td>
                                <model-list-select
                                  :list="systemTrucks"
                                  v-model="fuel_product.truck_id"
                                  option-value="id"
                                  option-text="truck_no"
                                  placeholder="select truck name"
                                ></model-list-select>
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="fuel_product.description"
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  min="0"
                                  step=".01"
                                  v-model="fuel_product.litre"
                                  @change="calculateLineTotal(fuel_product)"
                                />
                              </td>
                              <td>
                                <input
                                  class="form-control"
                                  type="number"
                                  min="0"
                                  step=".01"
                                  v-model="fuel_product.rate_per_litre"
                                  @change="calculateLineTotal(fuel_product)"
                                />
                              </td>
                              <td>
                                <input
                                  readonly
                                  class="form-control text-right"
                                  type="number"
                                  min="0"
                                  step=".01"
                                  v-model="fuel_product.total_price"
                                />
                              </td>
                              <td>
                                <input
                                  type="date"
                                  class="form-control date_loading"
                                  v-model="fuel_product.date_loading"
                                />
                              </td>
                              <td>
                                <model-list-select
                                  :list="systemConsignees"
                                  v-model="fuel_product.consignee_id"
                                  option-value="id"
                                  option-text="consignee_name"
                                  placeholder="select consignee name"
                                ></model-list-select>
                              </td>
                              <td>
                                <model-list-select
                                  :list="systemStations"
                                  v-model="fuel_product.station_id"
                                  option-value="id"
                                  option-text="station_name"
                                  placeholder="select station name"
                                ></model-list-select>
                              </td>
                            </tr>
                            <tr v-show="fuelitemsRows.length === 0">
                              <td colspan="8">
                                <p class="text-center alert-danger p-2">
                                  No products added/available.
                                </p>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td colspan="6" class="text-right">Sub Total</td>
                              <input
                                readonly
                                class="form-control text-right sub_total"
                                type="number"
                                min="0"
                                step=".01"
                                :value="invoice_subtotal"
                              />
                            </tr>
                            <tr>
                              <td colspan="6" class="text-right">Total</td>
                              <input
                                readonly
                                class="form-control text-right grand_total"
                                type="number"
                                min="0"
                                step=".01"
                                :value="invoice_total"
                              />
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                    <div class="col-md-12 mb-2">
                      <button
                        type="button"
                        class="btn btn-info"
                        @click="addFuelItems"
                      >
                        <i class="fa fa-plus-circle"></i>
                        Add
                      </button>
                    </div>
                    <button
                      type="submit"
                      class="btn btn-primary btn-flat creatingFuel btn-rounded"
                    >
                      <i class="fa fa-plus"></i> allocate fuel
                    </button>
                    <button
                      type="button"
                      class="btn-rounded btn-flat creatingFuelLoader btn-rounded"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        class="fa fa-spinner fa-spin"
                        style="font-size: 24px"
                      ></i>
                      please wait...
                    </button>
                  </div>
                </form>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ModelListSelect } from "vue-search-select";
import router from "../router/index";
export default {
  data() {
    return {
      invoice_subtotal: 0,
      invoice_total: 0,
    };
  },
  created() {
    this.loadTrucks();
    this.loadSuppliers();
    this.loadStations();
    this.loadConsignees();
  },
  computed: {
    ...mapGetters([
      "fuelitemsRows",
      "systemTrucks",
      "systemSuppliers",
      "systemStations",
      "systemConsignees",
    ]),
  },
  methods: {
    ...mapActions([
      "loadTrucks",
      "newFuel",
      "loadSuppliers",
      "newStation",
      "loadStations",
      "loadConsignees",
      "newConsignee",
    ]),
    ...mapMutations(["addFuelItems"]),
    calculateTotal() {
      var subtotal, total, totals;
      subtotal = this.fuelitemsRows.reduce(function (sum, product) {
        var lineTotal = parseFloat(product.total_price);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
      }, 0);

      if (!isNaN(subtotal)) {
        this.invoice_subtotal = subtotal.toFixed(2);
      } else {
        this.invoice_subtotal = "0.00";
      }
      total = subtotal;
      total = parseFloat(total);
      if (!isNaN(total)) {
        this.invoice_total = total.toFixed(2);
      } else {
        this.invoice_total = "0.00";
      }
    },
    calculateLineTotal(fuel_product) {
      var total =
        parseFloat(fuel_product.litre) *
        parseFloat(fuel_product.rate_per_litre);
      if (!isNaN(total)) {
        fuel_product.total_price = total.toFixed(2);
      }
      this.calculateTotal();
    },
    deleteRow(index, fuel_product) {
      var idx = this.fuelitemsRows.indexOf(fuel_product);
      console.log(idx, index);
      if (idx > -1) {
        this.fuelitemsRows.splice(idx, 1);
      }
      this.calculateTotal();
    },
  },
  components: {
    ModelListSelect,
  },
};
</script>
<style scoped>
.creatingFuelLoader {
  display: none;
}
.creatingStationLoader {
  display: none;
}
.creatingConsigneeLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/fuels/fuels.vue